export const CLIENT_EVENT_CODES = [
  // Automatic interceptors
  "REACT_RENDER_ERROR",
  "UNHANDLED_REJECTION",
  "QUERY_ERROR",
  "MUTATION_ERROR",
  // Auth-related
  "AUTH_CALLBACK_FAILED",
  "TOKEN_ACQUISITION_FAILED",
  // Network/API
  "API_REQUEST_FAILED",
  "NETWORK_TIMEOUT",
  // Generic fallback
  "UNKNOWN",
] as const;
